import OpenInNewIcon from "@material-ui/icons/OpenInNew";

import { ExternalLinkProps } from "./external-link.props";
import { IconButton } from "@material-ui/core";

export const ExternalLink = (props: ExternalLinkProps) => {
  return (
    <a tabIndex={-1} href={props.link} target="_blank" rel="noreferrer">
      <IconButton size="small">
        <OpenInNewIcon fontSize="small" />
      </IconButton>
    </a>
  );
};
